import Column from '@components/column'
import SectionHeading from '@commons/headings/section'
import { useSelector } from 'react-redux'
import { GeneralSetting } from '@apis'
import { useEffect, useState } from 'react'
import Table from '@components/table'
import TableActions from '@components/table/actions'
import { Formik } from 'formik'
import Fields from '@components/fields'
import Alert from '@commons/popups/alert'
import { useNavigate } from 'react-router-dom'
const HealthAdviceList = () => {
  const navigate = useNavigate()
  const { data: healthAdvices } = useSelector(
    (state: any) => state.healthAdvices,
  )
  const [deleteInfo, setDeleteInfo] = useState({
    visible: false,
    id: null,
    loading: false,
  })
  const columns = [
    {
      title: 'Category',
      key: 'category',
      render: (item: any) => {
        const parse = JSON.parse(item?.value)
        return parse.category
      },
    },
    {
      title: 'Advice Title',
      key: 'title',
      render: (item: any) => {
        const parse = JSON.parse(item?.value)
        return parse.title
      },
    },
    {
      title: 'Health Advice',
      key: 'description',
      render: (item: any) => {
        const parse = JSON.parse(item?.value)
        return parse.description
      },
    },
    {
      title: 'Active Status',
      key: 'status',
      render: (item: any) => {
        const parse = JSON.parse(item?.value)

        return (
          <Formik
            initialValues={{
              isActive: parse?.isActive || false,
            }}
            onSubmit={() => {}}
          >
            {() => {
              return (
                <Fields.Switch
                  name="isActive"
                  onChange={async (status) => {
                    await GeneralSetting.update({
                      id: item?.id,
                      data: {
                        key: item?.key,
                        value: JSON.stringify({
                          ...parse,
                          isActive: status,
                        }),
                      },
                    }).catch(() => {})
                  }}
                />
              )
            }}
          </Formik>
        )
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (item: any) => {
        return (
          <TableActions
            hasView={false}
            onClickEdit={() => {
              navigate(
                '/admin/settings/marketing-settings?tab=health-advices',
                {
                  state: item,
                },
              )
            }}
            onClickDelete={() => {
              setDeleteInfo({
                visible: true,
                id: item?.id,
                loading: false,
              })
            }}
          />
        )
      },
    },
  ]
  const fetchData = async () => {
    await GeneralSetting.getByGroup({
      id: 'health-advices',
      state: 'healthAdvices',
    }).catch(() => {})
  }

  const removeData = async () => {
    setDeleteInfo({
      ...deleteInfo,
      loading: true,
    })
    await GeneralSetting.remove({
      id: deleteInfo?.id,
      state: 'healthAdvices',
    })
      .then(() => {
        navigate('/admin/settings/marketing-settings?tab=health-advices')
      })
      .catch(() => {})
    setDeleteInfo({
      ...deleteInfo,
      visible: false,
      loading: false,
    })
  }

  useEffect(() => {
    if (!healthAdvices?.length) {
      fetchData()
    }
  }, [])

  return (
    <Column>
      <Column styleColumn="margin-bottom:30px;">
        <SectionHeading title="Health Advices" />
      </Column>
      <Table columns={columns} data={healthAdvices} />
      <Alert
        visible={deleteInfo?.visible}
        loading={deleteInfo?.loading}
        onClickOk={removeData}
        onClickClose={() => {
          setDeleteInfo({
            visible: false,
            id: null,
            loading: false,
          })
        }}
      />
    </Column>
  )
}

export default HealthAdviceList
